import axios from "axios";

/**
 * @description Create API call for /api/auth/logout
 *
 * @returns {Promise} axios.post result
 */
function APILogout() {
	let hostname = window.location.hostname;
	let protocol = window.location.protocol;
	let api_url = protocol + "//api." + hostname + "/api/auth/logout";

	return axios.post(
		api_url,
		null,
		{
			withCredentials: true
		}
	);
}

export { APILogout };